import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../components/Login.vue'
import DashboardPage from '../components/Dashboard.vue'
import RegisterByInvitation from '../components/RegisterByInvitation.vue'

const routes = [
  {
    path: '/:view?',
    name: 'Home',
    component: DashboardPage,
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterByInvitation
  },
 
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
